// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from '@/router'
import ElementUI from 'element-ui'
import * as filters from '@/utils/filter.js' // 全局格式化
import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import 'normalize.css/normalize.css' // CSS reset 替代方案
import '@/assets/icon/iconfont.css'
import 'default-passive-events'
import store from './store'
import moment from 'moment'

moment.locale('zh-cn')

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: 'medium' // 设置element-ui默认大小
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js